import { CashFund, Check, Employee, Expense, ExpenseType, PaymentType, Settings, CreditCard, Ticket, PaymentOrder, CreditPayment, Tax, AdjustmentNote } from "../../modules/administration"
import { DeliveryOrder, Delivery } from "../../modules/deliveries"
import { Vehicle, Driver, Roadmap } from "../../modules/logistics"
import { Branch } from "../../modules/manager"
import { Product, ProductPrices, Category } from "../../modules/products"
import { PurchaseOrder, Supplier } from "../../modules/purchases"
import { Budget, Customer, CustomerType, HoardOrder, SaleOrder } from "../../modules/sales"
import { Stock, UnitType } from "../../modules/stock"
import { Company, Request, User } from "../../modules/system"

export type DataType =
    Company |
    UnitType |
    User |
    TenantDataType

export type TenantDataType =
    AdjustmentNote |    
    Branch |
    Budget |
    CashFund |
    Category |
    Check |
    CreditCard |
    Customer |
    CustomerType |
    Delivery |
    DeliveryOrder |
    ExpenseType |
    Expense |
    HoardOrder |
    PaymentOrder |
    PaymentType |
    Product |
    ProductPrices |
    PurchaseOrder |
    Request |
    Roadmap |
    SaleOrder |
    Settings |
    Stock |
    Supplier |
    Tax |
    Ticket

export type NamedDataType =
    Branch |
    CashFund |
    Category |
    Check |
    CustomerType |
    Company |
    Customer |
    Employee |
    PaymentType |
    Product |
    Supplier |
    UnitType |
    User |
    Vehicle

export type CodedDataType =
    AdjustmentNote |    
    Budget |
    CreditPayment |
    Delivery |
    DeliveryOrder |
    HoardOrder |
    PaymentOrder |
    Product |
    PurchaseOrder |
    Roadmap |
    SaleOrder |
    Ticket

export type ArchivableDataType =
    Budget |
    CashFund |
    Category |
    Check |
    CreditCard |
    CreditPayment |
    Customer |
    CustomerType |
    Driver |
    Employee |
    Expense |
    ExpenseType |
    HoardOrder |
    PaymentOrder |
    PaymentType |
    PurchaseOrder |
    Product |
    Request |
    SaleOrder |
    Supplier |
    Tax |
    Vehicle

export type CancellableDataType =
    HoardOrder |
    SaleOrder

export type NumberProp = {
    n?: number
}

export type ListProp = DataType & {
    l: object[]
}

export enum TableName {
    ADJUSTMENT_NOTES = 'AdjustmentNotes',
    ADMIN = 'Admin',
    ADDRESSES = 'Addresses',
    BRANCHES = 'Branches',
    BUDGETS = 'Budgets',
    CASH_FUNDS = 'CashFunds',
    CATEGORIES = 'Categories',
    CHECKS = 'Checks',
    COMPANIES = 'Companies',
    CREDIT_CARDS = 'CreditCards',
    CREDIT_PAYMENTS = 'CreditPayments',
    CUSTOMERS = 'Customers',
    CUSTOMER_TYPES = 'CustomerTypes',
    DELIVERIES2 = 'Deliveries2',
    DELIVERY_ORDERS = 'DeliveryOrders',
    DELIVERY_ROADMAPS = 'DeliveryRoadmaps',
    DRIVERS = 'Drivers',
    EMPLOYEES = 'Employees',
    EXPENSE_TYPES = 'ExpenseTypes',
    EXPENSES = 'Expenses',
    FISCAL_DOCUMENTS = 'FiscalDocuments',
    HOARD_ORDERS = 'HoardOrders',
    LOTS = 'Lots',
    PAYMENT_ORDERS = 'PaymentOrders',
    PAYMENT_TYPES = 'PaymentTypes',
    PRODUCTS = 'Products',
    PRODUCT_PRICES = 'ProductPrices',
    PURCHASE_ORDERS = 'PurchaseOrders',
    REQUESTS = 'Requests',
    ROADMAPS = 'Roadmaps',
    SALE_ORDERS = 'SaleOrders',
    SETTINGS = 'Settings',
    STOCK = 'Stock',
    SUPPLIERS = 'Suppliers',
    TAXES = 'Taxes',
    TICKETS = 'Tickets',
    TRANSACTIONS = 'Transactions',
    UNIT_TYPES = 'UnitTypes',
    USERS = 'Users',
    VEHICLES = 'Vehicles'
}

export enum Currency {
    ARS = 'ARS',
    USD = 'USD'
}
